import { createFileRoute } from "@tanstack/react-router";
import { MarketingPage } from "@/content-site/components/marketing-page";
import { loadContentPage, contentHead } from "@/content-site/lib/page";
export const Route = createFileRoute("/_content/compare/")({
  loader: () => loadContentPage(["compare"]),
  head: ({ loaderData }) => contentHead(loaderData),
  component: Page,
});
function Page() {
  return <MarketingPage data={Route.useLoaderData()} />;
}
